export const options = [
  { label: 'SHI (06.048.539/0001-05)', value: '06048539000105' },
  { label: 'Taurus (01.452.651/0001-85)', value: '01452651000185' },
]
